/* global angular */
(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name FileBrowserControllerUpload
     *
     * @description
     * FileBrowserControllerUpload is inherited by FileBrowserController. It contains all logics relating to displaying upload docs and folders
     */
    angular.module('GorillaBoy')
    .factory('FileBrowserControllerUpload', [
        '$rootScope',
        '$timeout',
        '$filter',
        'SignalProvider',
        FileBrowserControllerUpload
    ]);
    function FileBrowserControllerUpload($rootScope, $timeout, $filter, SignalProvider) {
        var $scope = null;
        // Set the minimum progress so that the progress bar is always visable
        var FILE_PROGRESS_MIN = 2,
            FOLDER_PROGRESS_MIN = 2;
        return {
            initScope : initScopeFn
        };

        function initScopeFn(scopeVal) {
            $scope = scopeVal;
            $scope.$on('$destroy', function() {
                $scope = null;
            });

            /**
             * This function determines if a folder of a file is uploading based on if there is an
             * uploading progress bar displayed.
             * If the input resource is null, check for all selected folders and files.
             */
            $scope.isUploading = function(resource) {
                /* Check if the given files are uploading by checking if the file ids are
                 * in fileUnderUploading. Notice this is an O(n^2) algorithm though n is usually small
                 */
                function fileIsUploading(fileIds) {
                    var targetIsUploading = false;
                    if (!$rootScope.fileUnderUploading) {
                        return false;
                    }
                    angular.forEach($rootScope.fileUnderUploading, function(fileToUpload) {
                        if (fileIds.indexOf(fileToUpload.files[0].documentId) !== -1) {
                            targetIsUploading = true;
                        }
                    });
                    return targetIsUploading;
                }
                /* Check if the given folders are uploading by checking if the folder ids are
                 * in folderUploadingProgressMap
                 */
                function folderIsUploading(folderIds) {
                    if (!$rootScope.folderUploadingProgressMap) {
                        return false;
                    }
                    for (var i=0; i<folderIds.length; i++) {
                        if ($rootScope.folderUploadingProgressMap[folderIds[i]]) {
                            return true;
                        }
                    }
                    return false;
                }
                var isUploading = false;
                if (!resource) {
                    isUploading = fileIsUploading($scope.fileManagerInstance.selectedFiles()) || folderIsUploading($scope.fileManagerInstance.selectedFolders());
                } else {
                    isUploading = fileIsUploading([resource.Id]) || folderIsUploading([resource.Id]);
                }
                return isUploading;
            };

            /**
             * This function shows/updates uploading progress bar for files in both list and thumbnail view.
             * If the file is not in the current document list, it will add the file to the list.
             */
            $scope.showFileUploadProgressBar = function(file, progress) {
                // Handle special case when upload fails during uploading
                if(file.errorThrown && file.errorThrown !== '') {
                    if($rootScope.fileUnderUploading && $rootScope.fileUnderUploading[file.files[0].uploadTempID]) {
                        if (!$rootScope.fileUploaded) {
                            $rootScope.fileUploaded = {};
                        }
                        $rootScope.fileUploaded[file.files[0].uploadTempID] = file;
                        delete $rootScope.fileUnderUploading[file.files[0].uploadTempID];
                        $rootScope.$broadcast(SignalProvider.Document.fileUploadStatusChange, 'moveToDone', file);
                    }
                    $rootScope.$broadcast(SignalProvider.Document.fileUploadFailed, file);
                    return ;
                }

                // Handle normal case
                var alreadyInFileList = false;
                progress = Math.max(FILE_PROGRESS_MIN, progress);
                for(var i=0; i<$scope.documents.length; i++) {
                    if(file.File.documentId === $scope.documents[i].Id) {
                        alreadyInFileList = true;
                        break;
                    }
                }
                if (!alreadyInFileList) {
                    //Make sure to modify the File Manager when adding new files to the view model
                    $scope.fileManagerInstance.setFiles([file.File.docMetadata].concat($scope.fileManagerInstance.getFiles()));
                    $scope.setDocumentsAndFolders();
                }
                var statusDiv = $("#id_document_upload_status_" + file.File.documentId);
                var statusBar = statusDiv.find('.loadingIndicator');
                // Make the status div visible.
                statusDiv.show();
                statusBar.css('width', progress.toString()+'%');
                // hide progress bar when the progress is 100%.
                if (progress == 100) {
                    statusDiv.hide();
                }
            };
            /**
             * This function shows/updates uploading progress bar for folder in both list and thumbnail view.
             * It searches all folders that are in "folderUploadingProgressMap" and update the view if necessary
             */
            $scope.showFolderUploadProgressBar = function() {
                angular.forEach($scope.folders, function(folder) {
                    // if folder in current folder list is not in a uploading process, exit.
                    if(!$rootScope.folderUploadingProgressMap || !$rootScope.folderUploadingProgressMap[folder.Id]) {
                        return ;
                    }
                    var progressInfo = $rootScope.folderUploadingProgressMap[folder.Id];
                    var progress = Math.max(FOLDER_PROGRESS_MIN, parseInt(progressInfo.done / progressInfo.total * 100, 10));
                    var statusDiv = $("#id_folder_upload_status_" + folder.Id);
                    var statusBar = statusDiv.find('.loadingIndicator');
                    if (progress == 100) {
                        // when the progress is 100%
                        // 1. hide progress bar
                        // 2. remove folder from folderUploadingProgressMap%.
                        statusDiv.hide();
                        progressInfo.display = false;
                        delete $rootScope.folderUploadingProgressMap[folder.Id];
                    } else {
                        // Make the status div visible.
                        statusDiv.show();
                        progressInfo.display = true;
                        statusBar.css('width', progress.toString()+'%');
                    }
                });
            };

            $scope.addFolderTofolderUploadingProgressMap = function(parentFolderID) {
                $rootScope.folderUploadingProgressMap[parentFolderID] = {
                    total: 0,
                    pre: 0,
                    ing: 0,
                    done:0,
                    display: false
                };
            };

            /**
             * This listens to "SignalProvider.Document.fileUploadStatusChange". It updates the progress bar
             * under each folders (in file browser view) when there is either new file is added to uploadQueue
             * or file moves to the next stage.
             * "SignalProvider.Document.fileUploadStatusChange" is broadcasted when there is change in:
             * -- $rootScope.fileUploadQueue
             * -- $rootScope.fileUnderUploading
             * -- $rootScope.fileUploaded
             * It searches all folders that are in "folderUploadingProgressMap" and update the view if necessary
             * params:
             * event: event
             * eventType: There are three possiable options: 'moveToPre', 'moveToIng', and 'moveToDone'
             * file: this is the file object that is moved between the three lists stated above.
             */
            $scope.$on(SignalProvider.Document.fileUploadStatusChange, function(event, eventType, file) {
                // Add all involved folders to "folderUploadingProgressMap"
                if (!$rootScope.folderUploadingProgressMap) {
                    $rootScope.folderUploadingProgressMap = {};
                }
                // for pre list
                angular.forEach($rootScope.fileUploadQueue, function(file) {
                    angular.forEach(file.files[0].parentFolderIDs, function(parentFolderID) {
                        if(!$rootScope.folderUploadingProgressMap[parentFolderID]) {
                            $scope.addFolderTofolderUploadingProgressMap(parentFolderID);
                        }
                    });
                });
                // for ing list
                angular.forEach($rootScope.fileUnderUploading, function(file) {
                    angular.forEach(file.files[0].parentFolderIDs, function(parentFolderID) {
                        if(!$rootScope.folderUploadingProgressMap[parentFolderID]) {
                            $scope.addFolderTofolderUploadingProgressMap(parentFolderID);
                        }
                    });
                });

                // for each folder that get involved, update folderUploadingProgressMap accordingly
                angular.forEach(file.files[0].parentFolderIDs, function(involvedFolderID) {
                    switch(eventType) {
                        case 'moveToPre':
                            $rootScope.folderUploadingProgressMap[involvedFolderID].total++;
                            $rootScope.folderUploadingProgressMap[involvedFolderID].pre++;
                            break;
                        case 'moveToIng':
                            $rootScope.folderUploadingProgressMap[involvedFolderID].pre--;
                            $rootScope.folderUploadingProgressMap[involvedFolderID].ing++;
                            break;
                        case 'moveToDone':
                            $rootScope.folderUploadingProgressMap[involvedFolderID].ing--;
                            $rootScope.folderUploadingProgressMap[involvedFolderID].done++;
                    }
                });

                // for each folder in the current view, if done < total, display/update progress bar
                $scope.showFolderUploadProgressBar();
            });
            /**
             * This listens to "SignalProvider.Document.uploadProgress". It updates the uploading progress bar
             * for files in the current folder.
             * params:
             * event: event
             * progress: the progress of the upload
             * folderId: the folder ID to which the file is been uploaded
             * file: this is the file object that reports the progress
             */
            $scope.$on(SignalProvider.Document.uploadProgress, function(event, progress, folderId, file) {
                var documentIsInView = ($scope.folderState.activeFolderId === folderId) ||
                                       ($scope.userInfo.RootFolderId === folderId);
                // if the document is not in the current view, exit.
                if(!documentIsInView) {
                    return ;
                }
                // if the document is in the current file list, update progress bar.
                $timeout(function () {
                    $scope.showFileUploadProgressBar(file, progress);
                });
            });

            /**
             * This listens to "SignalProvider.Document.fileUploadFailed". It removes failed file if it is in
             * current document list
             * params:
             * event: event
             * file: this is the file object that reports the progress
             */
            $scope.$on(SignalProvider.Document.fileUploadFailed, function(event, file) {
                var removeDocumentFilter = function(doc) {
                    return (doc.Id !== file.File.documentId);
                };
                var documentIsInView = ($scope.folderState.activeFolderId === file.File.folderId) ||
                                       ($scope.userInfo.RootFolderId === file.File.folderId);
                // if the document is not in the current view, exit.
                if(!documentIsInView) {
                    return ;
                }
                // if the document is in the current file list, update progress bar.
                $timeout(function () {
                    var docIsInList = false;
                    for(var i=0; i<$scope.documents.length; i++) {
                        if(file.File.documentId === $scope.documents[i].Id) {
                            docIsInList = true;
                            break;
                        }
                    }
                    if(docIsInList) {
                        $scope.documents = $filter('filter')($scope.documents, removeDocumentFilter, true);
                    }
                });
            });
        }
    }

}(angular));
